import React from 'react';
import { Loader2 } from 'lucide-react';

interface ChatLoadingProgressProps {
  isVisible: boolean;
  progress: number;
  total: number;
  current: number;
  message: string;
}

export const ChatLoadingProgress: React.FC<ChatLoadingProgressProps> = ({
  isVisible,
  progress,
  total,
  current,
  message
}) => {
  if (!isVisible) return null;

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mx-4 mb-3">
      {/* Header */}
      <div className="flex items-center space-x-2 mb-2">
        <Loader2 className="h-4 w-4 text-blue-600 animate-spin" />
        <span className="text-sm font-medium text-blue-800">
          Loading Chats...
        </span>
        <span className="text-sm text-blue-600 ml-auto">
          {progress}%
        </span>
      </div>

      {/* Progress Bar */}
      <div
        role="progressbar"
        aria-valuenow={progress}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`Loading chats: ${progress}%`}
      >
        <div className="w-full bg-blue-200 rounded-full h-1.5">
          <div
            className="bg-blue-600 h-1.5 rounded-full transition-all duration-300 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
};
